import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "d-flex flex-column w-100" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_5 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_6 = { class: "ml-3 d-flex flex-column" }
const _hoisted_7 = { class: "my-0 text-gray" }
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "separator" }, null, -1)
const _hoisted_9 = { class: "label-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: "apartment-card m-2 card--slim",
    onClick: _ctx.selected
  }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                    require(`@/assets/images/entrancePlants/icon-apartment.svg`)
                                ,
                "aria-label": "icon-apartment"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.getLabelText(_ctx.firstLabel)) + " ", 1),
                _createVNode("small", _hoisted_7, _toDisplayString(_ctx.apartment.name), 1)
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.othersLabels, (label) => {
            return (_openBlock(), _createBlock("div", {
              class: "other-labels d-flex flex-column",
              key: label.labelId
            }, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.getLabelText(label)), 1)
            ]))
          }), 128))
        ]),
        _createVNode(_component_Button, {
          onClick: _ctx.selected,
          icon: "pi pi-chevron-right",
          class: "p-button-text p-button-secondary ml-5 mr-1"
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}